import {
  api_GlobalToken,
  api_AccessToken,
  flow_get_tokens_global,
} from "../stores/sagas";
import { fork, take, put, join, select, call } from "redux-saga/effects";
import { createAction, createReducer } from "redux-act";

export const post_galleries = createAction("post_galleries");

export const fetchingFalse = createAction("fetchingFalse");
export const loadingFalse = createAction("loadingFalse");
export const loadingDataFalse = createAction("loadingDataFalse");

export const failure_galleries = createAction("failure_galleries");

export const galleries = createReducer(
  {
    [post_galleries]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = true;
      return newState;
    },
    [fetchingFalse]: (state, payload) => {
      const newState = Object.assign({}, state, { ...payload.data });
      newState.isFetching = false;
      return newState;
    },
    [loadingDataFalse]: (state, payload) => {
      const newState = Object.assign({}, state, { ...payload.data });
      newState.isLoading = false;
      return newState;
    },
    [loadingFalse]: (state, payload) => {
      const newState = Object.assign({}, state, {});
      newState.isLoading = false;
      return newState;
    },
  },
  {
    isLoading: false,
    isFetching: true,
    galleries: [],
  }
);

export function* flow_post_galleries() {
  while (true) {
    const { payload } = yield take(post_galleries);

    const params = new FormData();
    params.append("image", payload.data.image);

    const { data, error } = yield call(
      api_AccessToken,
      `galleries`,
      "post",
      params,
      // payload.data,
      true
    );
    if (!error) {
      yield put(loadingFalse({ data }));
      !payload.page || payload.page(data.gallery.url);
    } else {
      yield put(loadingFalse({ error }));
      !payload.toast || payload.toast(error.message);
    }
  }
}
